import { Box, Button, Chip, Typography } from "@mui/material";
import { Email } from "@mui/icons-material";
import PropTypes from "prop-types";

export default function TableHeader({ title, stats, unassignedLogsCount, onViewUnassigned }) {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 3 },
        bgcolor: "#193e54",
        borderRadius: 2,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <Email sx={{ fontSize: 28 }} />
      <Box sx={{ flex: "1 1 280px" }}>
        <Typography component="h1" sx={{ color: "#fff", fontSize: "1.15rem", fontWeight: 700 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "#dbe8f2", mt: 0.5 }}>
          Configuración de destinatarios e historial de correos por concesión.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {[
          `${stats.totalReports || 0} comercios`,
          `${stats.totalEmails || 0} correos configurados`,
          `${stats.totalValidEmails || 0} con dirección`,
        ].map((label) => (
          <Chip
            key={label}
            size="small"
            label={label}
            sx={{ bgcolor: "#ffffff14", color: "#fff", border: "1px solid #ffffff40" }}
          />
        ))}
      </Box>
      {unassignedLogsCount > 0 && (
        <Button
          onClick={onViewUnassigned}
          size="small"
          sx={{ color: "#fff", textTransform: "none" }}
        >
          Ver {unassignedLogsCount} registros sin comercio
        </Button>
      )}
    </Box>
  );
}
TableHeader.propTypes = {
  unassignedLogsCount: PropTypes.number,
  onViewUnassigned: PropTypes.func,
  title: PropTypes.string.isRequired,
  stats: PropTypes.shape({
    totalReports: PropTypes.number,
    totalEmails: PropTypes.number,
    totalValidEmails: PropTypes.number,
  }).isRequired,
};
